// Backend spend figures are USD; the admin surfaces display AUD at a configurable rate
// (list pricing is modelled — invoiced actuals reconcile monthly, per the governance note).
const AUD_PER_USD = Number(import.meta.env.VITE_AUD_PER_USD) || 1.5;

export const aud = (usd: number) => usd * AUD_PER_USD;
export const audStr = (usd: number) =>
  `A$${aud(usd).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export { AUD_PER_USD };
